import { useEffect, useState } from 'react'

const MOBILE_BREAKPOINT = 768

export function useIsMobile() {
	// Initialize synchronously on the client to avoid a brief false → true flip
	// after hydration, which can cause portal swaps for overlays.
	const [isMobile, setIsMobile] = useState<boolean>(
		typeof window !== 'undefined'
			? window.innerWidth < MOBILE_BREAKPOINT
			: false,
	)

	useEffect(() => {
		const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`)
		const onChange = () => setIsMobile(window.innerWidth < MOBILE_BREAKPOINT)
		mql.addEventListener('change', onChange)
		// Ensure state is accurate after mount
		setIsMobile(window.innerWidth < MOBILE_BREAKPOINT)
		return () => mql.removeEventListener('change', onChange)
	}, [])

	return isMobile
}
